// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
:host {
  display: inline;
}

.revision-field-changed {
  display: inline;
}

.revision-field-old {
  color: #c62828;
  text-decoration: line-through;
  margin-right: 0.5em;
  font-weight: 400;
}

.revision-field-new {
  color: #2e7d32;
  font-weight: 500;
}

.revision-field-edit {
  cursor: pointer;
  color: #0066b2;
  margin-left: 4px;
}
.revision-field-edit mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  vertical-align: middle;
}
.revision-field-edit:hover {
  color: rgb(0, 58.1629213483, 101.5);
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
